import { render } from "./LoginBox.vue?vue&type=template&id=68ecd388&scoped=true"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import "./LoginBox.vue?vue&type=style&index=0&id=68ecd388&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68ecd388"

export default script